// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimAccumulatorModels {
    static getAttributeTypeMap() {
        return ClaimAccumulatorModels.attributeTypeMap;
    }
}
ClaimAccumulatorModels.discriminator = undefined;
ClaimAccumulatorModels.additionalProperties = false;
ClaimAccumulatorModels.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "Array<ClaimAccumulatorModel>"
    },
];
//# sourceMappingURL=claimAccumulatorModels.js.map